import React from 'react';
import { Carousel, Container } from 'react-bootstrap';
import { RiDoubleQuotesL, RiDoubleQuotesR } from "react-icons/ri";
import Photo1 from '../Medias/Photos/1711941960_0.png';
import Photo2 from '../Medias/Photos/ION_crop.png';
import Photo3 from '../Medias/Photos/S__83738637.png';

const testimonials = [
  {
    logo: Photo1,
    quote: "PT and Associates have been an invaluable legal partner in our M&A journey. Their exceptional expertise in corporate and M&A law was critical to the successful submission of our M&A application to the Energy Regulatory Commission. From strategic guidance to meticulous preparation of the application and market analysis, their support enabled us to navigate a highly complex transaction with clarity and confidence. The team’s deep understanding of sector-specific regulations, particularly within the energy industry, truly distinguishes them in this field. Their professionalism, responsiveness, and legal acumen make PT and Associates a trusted advisor for any company pursuing mergers and acquisitions in regulated sectors.",
    name: <>
      <h4 className='mb-1 fw-bold'>Nuttha Punjavorn</h4>
      <p className='mb-0'>SVP Contract & Permit Management</p>
      <p>Super Energy Corporation PCL</p>
    </>,
  },
  {
    logo: Photo2,
    quote: "PT and Associates have been instrumental in navigating the complex legal landscape of the energy sector. Their expertise in regulatory compliance, power purchase agreements, and direct power purchase structures has been invaluable in advancing our renewable energy projects. The team is meticulous in their legal analysis, and forward-thinking in their strategic counsel. Their professionalism and depth of knowledge make them an outstanding partner for any company seeking top-tier legal support in the energy sector.",
    name: <>
      <h4 className='mb-1 fw-bold'>Pete Peerakarn Manakit</h4>
      <p className='mb-0'>CEO</p>
      <p>ION Energy</p>
    </>,
  },
  {
    logo: Photo3,
    quote: "Under my leadership, I am committed to achieving our company's goals and strategies to boost international investments in Thailand and Japan. I have been fortunate to receive legal advisory support from Dr. Piti Eiamchamroonlarp and the team at PT & Associates (PTA). As an expert in energy law, Dr. Piti and the PTA team consistently demonstrate a deep understanding of direct power purchase agreements (PPAs) within the renewable energy sector. Their expertise in navigating cross-border regulatory requirements, particularly in the context of Thailand and foreign jurisdictions, has been invaluable. I commend Dr. Piti and the PTA team for their professionalism and steadfast legal support, which have been instrumental in SPCG’s pursuit of becoming a leading player across all sectors of the solar energy industry in Thailand.",
    name: <>
      <h4 className='mb-1 fw-bold'>Dr. Wandee Khunchornyakong Juljarern</h4>
      <p className='mb-0'>Chairperson and Chief Executive Officer</p>
      <p>SPCG Public Company Limited</p>
    </>,
  },
];

const SectionTestimonial = () => {
  return (
    <section id="testimonial" className='pt-5 pb-5'>
      <Container className="mb-5">
        <h1 className='font-header text-center mb-5'>Client Review</h1>
        <Carousel variant='dark' indicators="bottom">
          {testimonials.map((testimonial, index) => (
            <Carousel.Item key={index}>
              <div className="d-flex flex-column align-items-center text-center w-50 mx-auto border-color-primary p-3 px-4 rounded rounded-3 border">
                <div className='w-75 bg-img ratio-21x9' style={{ backgroundImage: `url(${testimonial.logo})`, backgroundColor: 'white', backgroundSize: 'contain' }}></div>
                <p className="lead fst-italic mb-0">
                  <RiDoubleQuotesL className='mb-3 me-1 tx-color-primary' /> {testimonial.quote} <RiDoubleQuotesR className='ms-1 mb-3 tx-color-primary' />
                </p>
                {testimonial.name ?
                  <h5 className='mt-3'>{testimonial.name}</h5>
                  : ''}
              </div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

export default SectionTestimonial;
